/**
 * HubInstallationComponent created by karora on 16/02/19.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

import { AppComponent } from '../app.component';

@Component({
  selector: 'hub-installation',
  template: `<hub-sub-menu></hub-sub-menu><installation [hubID]="hubID"></installation>`,
  styles: [],
})


export class HubInstallationComponent implements OnInit {
  hubID: number;

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.route.params.pipe(
      map(params => this.hubID = +params['hubid'])
    );
  }

}

